import React from 'react';

import { toast } from 'react-hot-toast';
import IoCheckmarkCircled from "react-icons/lib/io/checkmark-circled";
import { useTranslation } from 'react-i18next';

export const TutorToast = ({ message, isSuccess}) => {
  const { t } = useTranslation("tutor_assignment_modal");

  return (
    <div style={{
      backgroundColor: isSuccess ? '#016439' : '#FF0000',
      padding: '3rem',
      fontSize: '1.2rem',
      color: 'white',
      width: '35rem',
    position: 'relative'
  }}>
    <div className='toast-container' style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '1rem' }}>
      {isSuccess && <IoCheckmarkCircled size={24} />}
      <div className='toastBody'>{t(message)}</div>
    </div>
    <button
      style={{
        fontSize: "1rem",
        textDecoration: "underline",
        background: "none",
        border: "none",
        cursor: "pointer",
        color: "white",
        position: "absolute",
        bottom: "0.5rem",
        right: "0.5rem"
      }}
      onClick={() => toast.remove()}
    >
      {t('dismiss')}
    </button>
    </div>
  );
};